'use strict';

module.exports = require('csjs/get-css');
